import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {CanvasInitialView, CanvasStructure} from '@shared/models/structure';
import {FileUploadService} from '@core/services/file-upload.service';
import {FeatureFlagsService, FeatureFlag} from '@core/services/feature-flags.service';
import {CanvasEditorComponent} from '../canvas-editor/canvas-editor.component';

@Component({
  selector: 'motn-canvas-tile-editor',
  standalone: true,
  templateUrl: './canvas-tile-editor.component.html',
  styleUrls: ['./canvas-tile-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CanvasEditorComponent,
  ],
})
export class CanvasTileEditorComponent implements OnInit {
  @Input() tileId: string;
  @Input() canvasStructure: CanvasStructure;
  @Output() structureChange = new EventEmitter<CanvasStructure>();

  canvasImageUrl: string = '';
  canvasImageUuid: string = '';

  constructor(
    private fileUploadService: FileUploadService,
    private featureFlagsService: FeatureFlagsService,
  ) {}

  ngOnInit(): void {
    this.loadCanvasImage();
  }

  private loadCanvasImage(): void {
    if (!this.canvasStructure?.Image) {
      return;
    }

    this.canvasImageUuid = this.canvasStructure.Image;
    this.fileUploadService.fetch(this.canvasImageUuid).subscribe({
      next: (upload) => {
        if (upload?.URL) {
          this.canvasImageUrl = upload.URL;
        }
      },
    });
  }

  onImageChange(event: {uuid: string; url: string}): void {
    this.canvasImageUuid = event.uuid;
    this.canvasImageUrl = event.url;

    if (this.canvasStructure) {
      this.canvasStructure = {
        ...this.canvasStructure,
        Image: event.uuid
      };
      this.structureChange.emit(this.canvasStructure);
    }
  }

  onCanvasPointsChange(points: any[]): void {
    if (this.canvasStructure) {
      this.canvasStructure = {
        ...this.canvasStructure,
        Points: points
      };
      this.structureChange.emit(this.canvasStructure);
    }
  }

  get clusterEnabled(): boolean {
    return this.canvasStructure?.Cluster?.Enabled ??
      this.featureFlagsService.isFeatureEnabled(FeatureFlag.ENABLE_CANVAS_CLUSTERING_BY_DEFAULT);
  }

  onClusterChange(enabled: boolean): void {
    if (this.canvasStructure) {
      this.canvasStructure = { ...this.canvasStructure, Cluster: { Enabled: enabled } };
      this.structureChange.emit(this.canvasStructure);
    }
  }

  onInitialViewChange(initialView: CanvasInitialView): void {
    if (this.canvasStructure) {
      this.canvasStructure = { ...this.canvasStructure, InitialView: initialView };
      this.structureChange.emit(this.canvasStructure);
    }
  }
}
